import React from 'react';
import { Provider as StoreProvider } from 'react-redux';
import { Router } from 'react-router-dom';
import { renderRoutes } from 'react-router-config';
import { createBrowserHistory } from 'history';
import MomentUtils from '@date-io/moment';
import { ThemeProvider } from '@material-ui/styles';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';

import ScrollReset from 'components/ScrollReset';

import theme from './theme';
import routes from './routes';
import { configureStore } from './store';
import './assets/scss/index.scss';

const history = createBrowserHistory();
const store = configureStore();


const App = () => {
  return (

    <StoreProvider store={store}>
      <ThemeProvider theme={theme}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <Router history={history}>
            {renderRoutes(routes)}
            <ScrollReset />
          </Router>
        </MuiPickersUtilsProvider>
      </ThemeProvider>
    </StoreProvider>
  );
};

export default App;
